import $ from 'jquery';
import { component as defineComponent } from 'flightjs';

function ScrollToErrors() {
    this.scroll = function(e, options) {
        var $errors = this.$node.find('[data-field-error]');
        options = $.extend({}, options, {
            duration: 0,
        });

        if ($errors.length > 0) {
            var $firstError = $errors.first();
            $('html, body').animate(
                {
                    scrollTop: $firstError.offset().top,
                },
                options.duration
            );
        }
    };

    this.after('initialize', function() {
        this.scroll();
        this.on(document, 'errorsPopulated', this.scroll);
    });
}

export default defineComponent(ScrollToErrors);



// WEBPACK FOOTER //
// ./src/web/js/app/modules/scrollto-errors.js